import type { ReactNode } from 'react';
import { appScreenSrc, type AppScreenKey } from '../../data/appScreens';

interface AppPhoneProps {
  /** App screen to show; omit and pass children for a coded screen. */
  screen?: AppScreenKey;
  alt?: string;
  /** Tailwind width class; height follows the 600×1304 screen ratio. */
  className?: string;
  loading?: 'eager' | 'lazy';
  children?: ReactNode;
}

/**
 * A phone frame around one real app screen. The screens carry their own
 * status bar and Dynamic Island, so the frame is only the bezel.
 */
export default function AppPhone({ screen, alt = '', className = 'w-56', loading = 'lazy', children }: AppPhoneProps) {
  return (
    <div className={`${className} shrink-0 rounded-[2.4rem] bg-gray-950 p-[3.5%] shadow-2xl shadow-black/30 ring-1 ring-white/10`}>
      <div className="relative w-full aspect-[600/1304] overflow-hidden rounded-[2rem] bg-white [container-type:inline-size]">
        {screen ? (
          <picture>
            <source srcSet={appScreenSrc(screen, 'webp')} type="image/webp" />
            <img
              src={appScreenSrc(screen, 'jpg')}
              alt={alt}
              width={600}
              height={1304}
              loading={loading}
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </picture>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
